import { VFC } from 'react'
import { useSelector } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify'

import AuthenticationRenewal from 'authentication/shared/components/AuthenticationRenewal'
import EnvironmentWarning from 'infrastructure/Application/components/EnvironmentWarning'

import { Loading, Router as ApplicationRouter } from './components'
import { useToken, useHandleLanguage } from 'shared/hooks'

type ReduxState = { api: { isPending: boolean } }

const ApplicationContainer: VFC = () => {
  const isLoading = useSelector((state: ReduxState) => state.api?.isPending)

  useToken()
  useHandleLanguage()

  return (
    <>
      <Loading active={isLoading} />
      <EnvironmentWarning />
      <AuthenticationRenewal />
      <ApplicationRouter />
      <ToastContainer
        position={toast.POSITION.BOTTOM_CENTER}
        pauseOnFocusLoss={false}
        pauseOnHover={false}
      />
    </>
  )
}

export default ApplicationContainer
